import script from "./PageSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageSection.vue?vue&type=script&setup=true&lang=ts"

import "./PageSection.vue?vue&type=style&index=0&id=2cac7ce2&lang=scss"

const __exports__ = script;

export default __exports__